import { Outlet } from "react-router-dom";

import { HubBanner } from "~/ui/hub-banner";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { DesktopSidebar, MobileNavigation } from "./Navigation";

export interface Navigation {
  name: string;
  href: string;
}

export const HubLayout = () => {
  return (
    <>
      <HubBanner />
      <div
        className="flex min-h-screen flex-col"
        style={{ paddingTop: "var(--hub-banner-height, 0px)" }}
      >
        <MobileNavigation />

        <DesktopSidebar />

        <div className="flex flex-1 flex-col">
          <Header />

          <div className="flex flex-1 flex-col px-5 pb-6 pt-24 lg:px-16 lg:pb-4 lg:pl-72 lg:pt-28">
            <main className="flex-1">
              <Outlet />
            </main>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};
